// extracted by mini-css-extract-plugin
export default {"buttonCloseCase":"PatientDischargeButton_buttonCloseCase__OY+dX"};